import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucYoutube: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16  '
      viewBox='0 0 21 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M19.6758 2.64453C19.4648 1.80078 18.7969 1.13281 17.9883 0.921875C16.4766 0.5 10.5 0.5 10.5 0.5C10.5 0.5 4.48828 0.5 2.97656 0.921875C2.16797 1.13281 1.5 1.80078 1.28906 2.64453C0.867188 4.12109 0.867188 7.28516 0.867188 7.28516C0.867188 7.28516 0.867188 10.4141 1.28906 11.9258C1.5 12.7695 2.16797 13.4023 2.97656 13.6133C4.48828 14 10.5 14 10.5 14C10.5 14 16.4766 14 17.9883 13.6133C18.7969 13.4023 19.4648 12.7695 19.6758 11.9258C20.0977 10.4141 20.0977 7.28516 20.0977 7.28516C20.0977 7.28516 20.0977 4.12109 19.6758 2.64453ZM8.53125 10.1328V4.4375L13.5234 7.28516L8.53125 10.1328Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucYoutube
